import { useStaticQuery, graphql } from 'gatsby';

const useSiteMetadata = () => {
  const { site } = useStaticQuery(
    graphql`
      query GetSiteMetadata {
        site {
          siteMetadata {
            lang
            siteName
            ogType
            title
            description
            siteUrl
            image
          }
        }
        file(name: { in: "cos-paisatge" }) {
          id
          publicURL
        }
      }
    `
  );

  return site.siteMetadata;
};

export default useSiteMetadata;
